const HEX = /^#?([0-9a-f]{3}|[0-9a-f]{6})$/i;

/** "#3a7" / "33aa77" / "#33AA77" → [51, 170, 119], or null when not a hex colour. */
export const parseHex = (value) => {
	const match = HEX.exec((value || '').trim());
	if (!match) return null;
	const hex =
		match[1].length === 3
			? match[1]
					.split('')
					.map((c) => c + c)
					.join('')
			: match[1];
	return [0, 2, 4].map((i) => parseInt(hex.slice(i, i + 2), 16));
};

export const isValidHex = (value) => parseHex(value) !== null;

const toHex = (rgb) =>
	`#${rgb.map((v) => Math.round(v).toString(16).padStart(2, '0')).join('')}`;

const mix = (rgb, target, amount) =>
	rgb.map((v, i) => v + (target[i] - v) * amount);

const WHITE = [255, 255, 255];
const BLACK = [0, 0, 0];

/** Tint (towards white) or shade (towards black) per Chakra step; 500 is the colour itself. */
const STEPS = {
	50: [WHITE, 0.92],
	100: [WHITE, 0.8],
	200: [WHITE, 0.62],
	300: [WHITE, 0.42],
	400: [WHITE, 0.2],
	500: [WHITE, 0],
	600: [BLACK, 0.14],
	700: [BLACK, 0.28],
	800: [BLACK, 0.42],
	900: [BLACK, 0.56],
};

/** Chakra colour scale (50–900) built around `hex` as the 500 shade, or null when invalid. */
export const paletteFromHex = (hex) => {
	const rgb = parseHex(hex);
	if (!rgb) return null;
	return Object.fromEntries(
		Object.entries(STEPS).map(([step, [target, amount]]) => [
			step,
			toHex(mix(rgb, target, amount)),
		]),
	);
};

/** True when dark text reads better than white on this colour (YIQ brightness). */
export const isLightColor = (hex) => {
	const rgb = parseHex(hex);
	if (!rgb) return false;
	const [r, g, b] = rgb;
	return (r * 299 + g * 587 + b * 114) / 1000 >= 160;
};

export const rgbaFromHex = (hex, alpha) => {
	const rgb = parseHex(hex);
	return rgb ? `rgba(${rgb.join(', ')}, ${alpha})` : null;
};
